import { render, staticRenderFns } from "./TreatmentAreaByBrand.vue?vue&type=template&id=1bc4d006&"
import script from "./TreatmentAreaByBrand.vue?vue&type=script&lang=js&"
export * from "./TreatmentAreaByBrand.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentAreaByBrand.vue?vue&type=style&index=0&id=1bc4d006&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports